export default "/assets/images/mama-to-be-crop.59be81654060426b.webp";